import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Route } from '../../side-drawer.component';
import * as classes from './nav-item.scss';
import { NavBox } from '../nav-box/nav-box';

interface NavItemProperties {
  route: Route;
  small: boolean;
  show: boolean;
  toggleActiveChild: any;
  toggleSidebar: () => void;
}

interface NavItemState {
  showNavChildren: boolean;
}

export class NavItem extends React.Component<NavItemProperties, NavItemState> {
  state: NavItemState = { showNavChildren: false };

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (event: Event) => {
    this.setState(() => {
      return { showNavChildren: false };
    });
  };

  toggleNavChildren(toggle: boolean) {
    this.setState({ showNavChildren: toggle });
  }

  getClasses(route: Route): string {
    let classArr = [classes.navItem];

    if (this.props.small) {
      classArr.push(classes.small);
    } else {
      classArr.push(classes.large);
    }

    if (this.props.show) {
      classArr.push(classes.visible);
    } else {
      classArr.push(classes.hidden);
    }

    if (route.isActive) {
      classArr.push(classes.active);
    }

    return classArr.join(' ');
  }

  getTextClasses(route: Route): string {
    let classesArr = [classes.path];
    if (route.isActive) {
      classesArr.push(classes.activeChild);
    }

    return classesArr.join(' ');
  }

  renderNavItem(route: Route): any {
    if (route.children.length) {
      return (
        <li
          onMouseEnter={e => this.toggleNavChildren(true)}
          onTouchStart={e => this.toggleNavChildren(true)}
          // onTouchEnd={(e) => this.toggleNavChildren(false)}
          onClick={e => {
            this.toggleNavChildren(false);
            this.props.toggleSidebar();
          }}
          onMouseLeave={e => this.toggleNavChildren(false)}
          key={route.name}
          className={this.getClasses(route)}
        >
          <span className={this.getTextClasses(route)}>{route.name}</span>
          <NavBox
            show={this.state.showNavChildren}
            routes={route.children}
            toggleActiveChild={this.props.toggleActiveChild}
            toggleSidebar={this.props.toggleSidebar}
          />
        </li>
      );
    }

    return (
      <li
        key={route.name}
        className={this.getClasses(route)}
        onClick={e => {
          this.toggleNavChildren(false);
          this.props.toggleActiveChild(route.name);
          this.props.toggleSidebar();
        }}
      >
        <NavLink className={classes.path} activeClassName="active" to={route.path}>
          {route.name}
        </NavLink>
      </li>
    );
  }

  render() {
    return <>{this.renderNavItem(this.props.route)}</>;
  }
}



// WEBPACK FOOTER //
// ./src/side-drawer/_components/nav-item/nav-item.tsx